import { Component, OnInit, OnDestroy, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, startWith } from "rxjs/operators";

@Component({
  standalone: false,
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.component.html",
  styleUrls: ["./auth-layout.component.scss"]
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  test: Date = new Date();
  public isCollapsed = true;
  footerType = signal<string>("default");

  constructor() {
    // takeUntilDestroyed() works here because this runs in an injection context
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        let r = this.route;
        while (r.firstChild) r = r.firstChild;
        this.footerType.set(r.snapshot.data["footer"] ?? "default");
      });
  }

  ngOnInit() {
    document.body.classList.add("bg-default");
    const navbar = document.getElementsByClassName("navbar-horizontal")[0];
    navbar?.classList.add("navbar-light", "navbar-transparent");
  }

  ngOnDestroy() {
    document.body.classList.remove("bg-default");
    const navbar = document.getElementsByClassName("navbar-horizontal")[0];
    navbar?.classList.remove("navbar-light", "navbar-transparent");
  }
}